import _ from './flex.module.scss'
import React from 'react'
import {$, $$$} from '../shared/class-name'

const cssSize = value => typeof value === 'number' ? `${value}px` : value

export const Flex = ({
    row = true,
    column = false,
    stretch = false,
    spaceBetween = false,
    horizontal = 'center',
    vertical = 'center',
    className,
    children,
    gap,
    style,
    relative,
    padding,
}) => <div className={$$$(
    $(_.root), $(_.row, row && !column), $(_.column, column), $(_.stretch, stretch), $(_.relative, relative), $(className),
    $(_.spaceBetween, spaceBetween),
    $(_.horizontalLeft, horizontal === 'left'), $(_.horizontalRight, horizontal === 'right'),
    $(_.verticalTop, vertical === 'top'), $(_.verticalBottom, vertical === 'bottom'),
    $(_.padding, padding)
)}
    style={{gap, ...(gap != null ? {'--flex-gap': cssSize(gap)} : {}), ...(style || {})}}
>{children}</div>
